/* eslint-disable import/no-anonymous-default-export */

// import { modFetch } from './lib/fetch'
import { modAxios } from './lib/axios';

const consoleBackend = modAxios(process.env.NEXT_PUBLIC_CONSOLE_BACKEND_ENDPOINT);
const iamBackend = modAxios(process.env.NEXT_PUBLIC_IAM_ENDPOINT);
const connectBackend = modAxios(process.env.NEXT_PUBLIC_CONNECT_ENDPOINT);

// Exporting...
// export { default as fetch } from './lib/fetch';
// export { default as axios } from './lib/axios';
export default {
  consoleBackend,
  iamBackend,
  connectBackend,
};
